import type { Namespace } from 'i18next';
import { useCallback, useMemo } from 'react';
import { useTranslation as _useTranslationBase } from 'react-i18next';

import type { Locales } from '@/app/_shared/i18n/generated/locales';
import { type Lang, isLang } from '@/app/_shared/i18n/types';

export const useTranslation = (ns?: Namespace) => {
	const { t, i18n } = _useTranslationBase(ns);

	const currentLang = useMemo(() => {
		return isLang(i18n.resolvedLanguage) ? i18n.resolvedLanguage : 'en';
	}, [i18n.resolvedLanguage]);

	const setLanguage = useCallback(
		async (language?: Lang | null) => {
			const browserLanguage = window.navigator.language;
			await i18n.changeLanguage(language ?? browserLanguage);
		},
		[i18n],
	);

	return useMemo(
		() => ({
			// biome-ignore lint/suspicious/noExplicitAny: <explanation>
			t: (key: Locales, option?: { [key: string]: any }) => t(key, option),
			originalT: t,
			currentLang,
			setLanguage,
			i18n,
		}),
		[t, currentLang, setLanguage, i18n],
	);
};
